import { render, staticRenderFns } from "./make-public-models.html?vue&type=template&id=d8712474&scoped=true&external"
import script from "./make-public-models.js?vue&type=script&lang=js&external"
export * from "./make-public-models.js?vue&type=script&lang=js&external"
import style0 from "./make-public-models.scss?vue&type=style&index=0&id=d8712474&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8712474",
  null
  
)

export default component.exports